
export const getTotalUploadSize = (fileList) => {
    let size = 0;
    fileList.forEach(file => {
        size += file.size;
    })
    return size;
}